export enum DocumentOrFolderOrigin {
  CPA = 1,
  BO = 2,
  MIGRATION = 4,
}
